import * as API from './../../base/api_service';
import * as serviceCallConfig from './../../config/api_urls';

export var ADMIN_SELECT = 'ADMIN_SELECT';
export var ADMIN_SELECT_DATA = 'ADMIN_SELECT_DATA';
export var ADMIN_SELECT_DETAILS_FAIL = 'ADMIN_SELECT_DETAILS_FAIL';

export var ADMIN_REQUEST_TO_DEACTIVATE = 'ADMIN_REQUEST_TO_DEACTIVATE';
export var ADMIN_REQUEST_TO_DEACTIVATE_RESPONSE_DATA = 'ADMIN_REQUEST_TO_DEACTIVATE_RESPONSE_DATA';



export var getFacilityAdmins = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.ADMIN_SELECT),//endPoint
            '',//payLoad
            serviceCallConfig.ADMIN_SELECT,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



export var adminSelect_data = (data) => ({
    type: ADMIN_SELECT_DATA,
    data: data
});

export var adminSelect_data_failed = (data) => {
    return ({
        type: ADMIN_SELECT_DETAILS_FAIL,
        data: data
    });
};


// export var adminDeactivate = (data) => {

//     return (dispatch, getState) => {
//         API.makeServiceCall(
//             serviceCallConfig.API_POST,
//             dispatch,
//             serviceCallConfig.get(serviceCallConfig.ADMIN_DEACTIVATE),
//             data,
//             serviceCallConfig.ADMIN_DEACTIVATE,
//             false,
//             '',
//             '',
//             '',
//         );
//     };
// };
export var adminDeactivate = (data) => {
    return (dispatch, getState) => {
         API.makeServiceCall(
        serviceCallConfig.API_POST,//reqType
        dispatch,//dispatch
        serviceCallConfig.get(serviceCallConfig.ADMIN_REQUEST_TO_DEACTIVATE),//endPoint
        data,//payLoad
        serviceCallConfig.ADMIN_REQUEST_TO_DEACTIVATE,//requestFrom
        false,//isURLEncoded
        getState().User.loginData.data.accessToken, //authKey
        '',//api_key
        '',//getParams
        false,//multipart
        getState().User.loginData.data.uniqueKey, //uniqueKey
    );
    }
}

export var adminDeactivate_data = (data) => ({
    type: ADMIN_REQUEST_TO_DEACTIVATE_RESPONSE_DATA,
    data: data
})

export var adminDeactivate_data_failed = (data) => {
    return ({
        type: ADMIN_REQUEST_TO_DEACTIVATE_RESPONSE_DATA,
        data: data
    });
};



/** WEBPACK FOOTER **
 ** ./src/actions/admin/adminSetting_action.js
 **/